import { render, staticRenderFns } from "./CycleDetails.vue?vue&type=template&id=24162552&scoped=true&"
import script from "./CycleDetails.vue?vue&type=script&lang=js&"
export * from "./CycleDetails.vue?vue&type=script&lang=js&"
import style0 from "./CycleDetails.vue?vue&type=style&index=0&id=24162552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24162552",
  null
  
)

export default component.exports